const Form = require('./form');

$(() => {
	new Form($('.js-apply'));
});